export default {
  OPERACION_PARCELA_COORDENADA: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
